if (self.location.host === "localhost:5173" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    console.log("dev");
    regs.forEach((reg) => reg.unregister());
  });
}

